"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadesAndDetails = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationProductDetail = require("@ori/presentation-product-detail");
const ShadesAndDetails = exports.ShadesAndDetails = (0, _mui.styled)(_presentationProductDetail.ShadesAndDetails)(({
  theme
}) => ({
  boxSizing: 'content-box',
  order: 'unset',
  [theme.breakpoints.up('md')]: {
    order: 'unset'
  },
  [`.${_presentationComponents.shadeClasses.root}`]: {
    boxSizing: 'content-box'
  }
}));